/**
 * Validate a user-supplied URL for safe rendering as an external href.
 * Returns the URL if it uses http/https, or prepends https:// if scheme is
 * missing. Returns null for `javascript:`, `data:`, `file:`, etc.
 */
export function safeExternalUrl(input: string | null | undefined): string | null {
  if (!input) return null;
  const trimmed = input.trim();
  if (!trimmed) return null;
  // Reject anything containing control chars or whitespace
  if (/[\s\u0000-\u001f]/.test(trimmed)) return null;
  // If no scheme, assume https
  const withScheme = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const u = new URL(withScheme);
    if (u.protocol !== "http:" && u.protocol !== "https:") return null;
    return u.toString();
  } catch {
    return null;
  }
}
